module.exports = "/0e09b12549dd9d208517dc591c025d14.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/brands/captain-morgan.png
 ** module id = 2203
 ** module chunks = 0
 **/